import { SimpleMenu } from "@components";
import { useTranslation } from "react-i18next";

const MenuProfile = function ({ active }) {
  const { t } = useTranslation();

  return (
    <SimpleMenu
      title={t("profil_bank")}
      active={active}
      menu={[
        {
          text: t("riwayat_kami"),
          link: "/profile/history",
        },
        {
          text: t("visi_misi"),
          link: "/profile/vision-mission",
        },
        {
          text: t("segmen_binis"),
          link: "/profile/business-segment",
        },
        {
          text: t("anak_perusahaan"),
          link: "/profile/subsidiary",
        },
        {
          text: t("budaya_perusahaan"),
          link: "/profile/corporate-culture",
        },
        {
          text: t("penghargaan"),
          link: "/profile/award",
        },
        {
          text: t("bank_koresponden"),
          link: "/profile/correspondent-bank",
        },
        {
          text: t("lembaga_profesi_perusahaan"),
          link: "/profile/institute-bank",
        },
        {
          text: t("hubungi_kami"),
          link: "/profile/contact-us",
        },
      ]}
    />
  );
};
export default MenuProfile;
